import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoRootModule } from './transloco-root.module';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedRoutingModule } from './shared-routing.module';
import { AboutUsComponent } from './components/about-us/about-us.component';
import { NameFormatPipe } from './utils/pipes/name-format.pipe';
import { DropdownDirective, DropdownMenuDirective, DropdownToggleDirective } from './utils/directives/dropdown.directive';
import { SvgIconComponent } from './components/svg-icon/svg-icon.component';
import { HeaderContentComponent } from './components/header-content/header-content.component';


@NgModule({
    imports: [
        CommonModule,
        SharedRoutingModule,
        ReactiveFormsModule,
        TranslocoRootModule,
        AboutUsComponent,
        HeaderContentComponent,
        SvgIconComponent,
        NameFormatPipe,
        DropdownDirective,
        DropdownToggleDirective,
        DropdownMenuDirective,
    ],
    exports: [
        TranslocoRootModule,
        ReactiveFormsModule,
        AboutUsComponent,
        HeaderContentComponent,
        SvgIconComponent,
        NameFormatPipe,
        DropdownDirective,
        DropdownToggleDirective,
        DropdownMenuDirective,
    ],
    providers: [
        NameFormatPipe,
    ],
})
export class SharedModule { }
